
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.656 16.956a2.018 2.018 0 01-1.59-1.467 2.761 2.761 0 01-.032-.818 1.997 1.997 0 011.331-1.57 1.991 1.991 0 012.388.932c.186.344.254.651.235 1.057-.025.53-.212.949-.591 1.324a1.997 1.997 0 01-1.741.542zM8.6 10.952a1.902 1.902 0 01-1-.552 1.884 1.884 0 01-.585-1.406c0-.557.187-1.007.585-1.404a1.882 1.882 0 011.405-.586c.557 0 1.007.188 1.405.586.397.397.585.847.585 1.404 0 .557-.188 1.008-.585 1.405-.3.3-.609.469-1.007.551a2.551 2.551 0 01-.8 0zm.142-5.972a1.998 1.998 0 01-1.709-1.66 2.762 2.762 0 01.033-.818A2.018 2.018 0 018.502 1.07a2.676 2.676 0 011-.002 2 2 0 011.432 1.425c.055.198.074.61.04.828a1.995 1.995 0 01-1.731 1.66c-.22.026-.283.026-.5-.001z"}})])
          )
        }
      }
    